import { IColumnVisibility } from 'components/DataTable/types'

// Shared <TargetTable> config for the GooglePlace doors tables (lodging-doors +
// convenience-doors). Both render the same `GooglePlaceBaseDoorTableColumns`, so
// their sortable fields, initial column order, default visibility, and the
// doors-mode proxy accessors are identical — kept here as one source of truth so
// a door-column change can't drift between the two configs. Per-vertical bits
// (slugs, filterset, export modal, list/summary actions, inCampaignsKey) stay in
// each table's own config.

export const GOOGLE_PLACE_DOORS_SORTABLE_FIELDS: string[] = [
  'note_count',
  'contact_count',
  'deal_count',
  'name',
  'address',
  'city',
  'state',
  'country',
  'phone',
  'website',
  'reviews_avg',
  'reviews_cnt',
  'chain_doors_cnt',
]

export const GOOGLE_PLACE_DOORS_INITIAL_COLUMN_ORDER: string[] = [
  'name',
  'address',
  'city',
  'state',
  'zipcode',
  'place_url',
  'phone',
  'door_taglist',
  'door_distributors',
  'reviews_avg',
]

export const GOOGLE_PLACE_DOORS_DEFAULT_COLUMN_VISIBILITY: IColumnVisibility<any> =
  {
    name: true,
    address: true,
    city: true,
    state: true,
    place_url: true,
    phone: true,
    door_taglist: true,
    door_distributors: true,
    reviews_avg: true,
    zipcode: true,
    country: false,
    reviews_cnt: false,
    website: false,
    chain_doors_cnt: false,
    deal_count: false,
    campaigns: false,
    sales_stages: false,
    account_owners: false,
    chain_proxy_taglist: false,
    note_count: false,
    chain_proxy_distributors: false,
  }

// Doors-mode accessor keys shared by every GooglePlace doors table: the row is a
// door proxy keyed by `id`, linking to its parent chain via `chain_proxy.id`.
export const GOOGLE_PLACE_DOORS_PROXY_ACCESSORS = {
  isDoorsTable: true,
  chainProxyIdAccessorKey: 'chain_proxy.id',
  doorProxyIdAccessorKey: 'id',
} as const
